export const OPEN_TRAVEL_PLANS: any[] = [
    {
        'DC Visit Transit': 'Visit',
        'DC Travel Country': 'Algeria',
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': 'By Air/Sea',
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '20'
    },
    {
        'DC Visit Transit': 'Transit',
        'DC Travel Country': 'Turkiye',
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': 'By Air/Sea',
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '5'
    },
    {
        'DC Visit Transit': 'ReEntry',
        'DC Travel Country': 'United Arab Emirates',
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': 'By Air/Sea',
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '20'
    }
];
export const OPEN_TRAVEL_PLANS_AR: any[] = [
    {
        'DC Visit Transit': "زيارة",
        'DC Travel Country': "الجزائر",
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': "جواً / بحراً",
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '20'
    },
    {
        'DC Visit Transit': "عبور",
        'DC Travel Country': "تركيا", //"تركية",
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': "جواً / بحراً",
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '5'
    },
    {
        'DC Visit Transit': "إعادة الدخول",
        'DC Travel Country': "الإمارات العربية المتحدة",
        'DC Travel Start Date': '',
        'DC Travel End Date': '',
        'DC Transport Means': "جواً / بحراً",
        'DC Additional Vchor': '0',
        'DC Additional Cfoil': '20'
    }
];